module.exports = __webpack_public_path__ + "static/media/image-opinion-campaign-donate-2.69046f80.png";